const meta = {
  terraform: 'Terraform provider',
  pulumi: 'Pulumi provider',
};

export default meta;
